//
import React from 'react'
import AppContext from "../../../context/AppContext";
//
import {Row, Col} from "antd";

class Form extends React.Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);
        this.state = {
            showCategoryDrawer: false
        }
    }

    /**
     * toggle loading state
     */
    loadToggle = () => this.setState({loading: !this.state.loading})

    /**
     * render content
     * @return {JSX.Element}
     */
    content = () => {

        /** @type {AppBase} */
        const $app = this.context

        /** @type {InputHelper} */
        const $form = this.context.HInput.new(this)

        let $left = (
            <>
                {$form.text('title')}
                {$form.autoComplete('category')}
            </>
        )
        let $right = (
            <>
                <Row>
                    <Col span={11}>
                        {$form.number('price')}
                    </Col>
                    <Col span={11} offset={2}>
                        {$form.number('weight')}
                    </Col>
                </Row>
                {$form.select('box_id')}
            </>
        )

        let $items = $form.renderFieldsByPositions('', $left, $right)

        let $formContent = $form.render($items, {
            onFinish: () => {
                this.loadToggle()
                $app.record.save(this.state.attributes, (res) => {
                    this.loadToggle()
                    return !$form.requestHasErrors(res)
                })
            }
        })

        return (
            <>
                {$formContent}
            </>
        )
    }

    render = () => this.content()
}

export default Form;